import { useState } from 'react';
import './styles.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import MainScreen from '../../components/MainScreen';
import PreFooter from '../../components/PreFooter';
import { InlineWidget } from 'react-calendly';
import Back from './bg.jpg';
import Popup from '../../components/Popup';

const MainPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <MainScreen
        title='Revenue Cycle Solutions'
        text='Comprehensive consulting, staffing, and assessment services that optimize your revenue cycle performance and drive bottom-line results.'
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
        background={Back}
      />

      <div className='descriptionBlock'>
        <span className='blockTitle'>Transform Your Revenue Cycle</span>
        <span className='blockText'>
          Choose from our comprehensive consulting services or start with an in-depth assessment to identify optimization
          opportunities.
        </span>

        <div className='descriptionBlockPoints'>
          <div className='descriptionBlockPoint'>
            <span className='descriptionBlockPointIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='41' height='48' viewBox='0 0 41 48' fill='none'>
                <path
                  d='M26.054 8.20492C23.9972 5.50392 21.0331 3.76327 17.7061 3.28309C14.3185 2.80291 10.9915 3.64322 8.26935 5.68398C5.54721 7.72474 3.79295 10.6658 3.30901 13.9671C2.82508 17.3283 3.67197 20.6296 5.72869 23.3306C8.20886 26.6318 12.0198 28.3724 15.8913 28.3724C18.553 28.3724 21.2146 27.5321 23.5133 25.8515C29.139 21.6499 30.2884 13.787 26.054 8.20492ZM22.5454 24.591C17.6456 28.2524 10.689 27.232 6.99902 22.3702C3.30901 17.5084 4.33738 10.6058 9.23722 6.94445C11.173 5.50392 13.4716 4.72362 15.8913 4.72362C16.4357 4.72362 16.9197 4.78365 17.4641 4.84367C20.4282 5.26383 22.9689 6.76439 24.7836 9.10526C28.4736 14.0271 27.4453 20.9297 22.5454 24.591Z'
                  fill='#F39B38'
                />
                <path
                  d='M40.451 43.5581L27.5058 26.5117C32.6476 21.0497 33.313 12.4665 28.5946 6.28421C26.054 2.92295 22.3035 0.762148 18.1295 0.161924C13.8951 -0.4383 9.72115 0.642103 6.33361 3.16304C2.94606 5.68398 0.768355 9.40537 0.163437 13.5469C-0.441482 17.7485 0.647372 21.89 3.18803 25.2513C5.72869 28.6125 9.47919 30.7733 13.6531 31.3736C14.4395 31.4936 15.1654 31.5536 15.9518 31.5536C18.432 31.5536 20.8517 30.9534 23.0899 29.873L35.9746 46.9194C36.4586 47.5196 37.0635 47.8797 37.8499 47.9998C37.9709 47.9998 38.0918 47.9998 38.2128 47.9998C38.8177 47.9998 39.4227 47.8197 39.9066 47.4596C41.1164 46.4992 41.3584 44.7585 40.451 43.5581ZM13.8951 29.813C10.0841 29.2728 6.75705 27.292 4.45836 24.2909C2.15967 21.2898 1.1918 17.5084 1.73623 13.787C2.28065 10.0056 4.27688 6.70436 7.30148 4.42351C9.78164 2.56282 12.8062 1.60246 15.8308 1.60246C16.4962 1.60246 17.2221 1.66248 17.8876 1.72251C21.6985 2.26271 25.0256 4.24345 27.3243 7.24457C32.0426 13.4869 30.7723 22.4302 24.4812 27.112C21.4566 29.3928 17.6456 30.3532 13.8951 29.813ZM38.9387 46.1391C38.6968 46.3191 38.3943 46.3792 38.0918 46.3792C37.7894 46.3191 37.4869 46.1991 37.3054 45.899L24.4207 29.0327C24.7836 28.7926 25.0861 28.6125 25.449 28.3724C25.7515 28.1324 26.054 27.8322 26.3564 27.5922L39.1807 44.5185C39.5436 45.0587 39.4227 45.7789 38.9387 46.1391Z'
                  fill='#F39B38'
                />
                <path
                  d='M17.0407 7.66472C16.6172 7.6047 16.1938 7.84479 16.0728 8.26495C15.9518 8.6851 16.2543 9.10526 16.6777 9.2253C19.8838 9.88555 21.5776 11.3261 22.001 13.6069C22.0615 13.9671 22.4244 14.2672 22.7874 14.2672C22.8479 14.2672 22.9084 14.2672 22.9084 14.2672C23.3318 14.2072 23.6343 13.787 23.5738 13.3668C23.0899 10.3657 20.8517 8.44501 17.0407 7.66472Z'
                  fill='#F39B38'
                />
              </svg>
            </span>
            <span className='descriptionBlockPointTitle'>Consulting & Staffing</span>
            <span className='descriptionBlockPointText'>
              Expert solutions that drive bottom-line results through customized revenue cycle optimization, staffing, and
              technology implementation.
            </span>
            <div className='descriptionBlockPointItems'>
              <ul className='descriptionBlockPointList'>
                <li>AR Management & Outsourcing</li>
                <li>At-the-Elbow Support</li>
                <li>Interim Leadership & Staffing</li>
              </ul>
              <ul className='descriptionBlockPointList'>
                <li>AI, Analytics & Dashboards</li>
                <li>EHR Optimization</li>
                <li>Process Improvement</li>
              </ul>
            </div>
          </div>
          <div className='descriptionBlockPoint'>
            <span className='descriptionBlockPointIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
                <path
                  fill-rule='evenodd'
                  clip-rule='evenodd'
                  d='M11.8628 14.8466H18.3547C18.5685 14.8466 18.7742 14.9313 18.9255 15.0825C19.0767 15.2338 19.1614 15.4395 19.1614 15.6533V40.4655C19.1614 40.6813 19.0767 40.885 18.9255 41.0363C18.7742 41.1876 18.5685 41.2723 18.3547 41.2723H11.8628C11.4171 41.2723 11.0561 40.9113 11.0561 40.4655V15.6534C11.0561 15.2076 11.4171 14.8466 11.8628 14.8466ZM40.259 35.2859V35.2839C40.259 35.7297 39.896 36.0907 39.4523 36.0907C39.0066 36.0907 38.6456 35.7297 38.6456 35.2839C38.6456 34.2876 37.0342 33.7753 36.1387 34.5377C35.2957 35.2577 35.9713 36.3953 37.2056 36.3953C38.7988 36.3953 40.259 37.5348 40.259 39.1201C40.259 40.427 39.2526 41.4456 38.0123 41.7481V42.5952L38.0103 42.5972C38.0103 43.0429 37.6493 43.404 37.2036 43.404C36.7579 43.404 36.3969 43.0429 36.3969 42.5972V41.7501C35.1546 41.4456 34.1502 40.429 34.1502 39.1221C34.1502 38.6764 34.5112 38.3153 34.9569 38.3153C35.4006 38.3153 35.7636 38.6764 35.7636 39.1221C35.7636 40.1185 37.375 40.6308 38.2704 39.8684C39.1155 39.1483 38.4378 38.0108 37.2036 38.0108C35.6103 38.0108 34.1502 36.8712 34.1502 35.2859C34.1502 33.979 35.1565 32.9604 36.3969 32.6579V31.8088C36.3969 31.3631 36.7579 31.0021 37.2036 31.0021C37.6493 31.0021 38.0103 31.3631 38.0103 31.8088V32.6559C39.2526 32.9605 40.257 33.977 40.257 35.2839L40.259 35.2859ZM37.2036 26.4077C38.0305 26.4057 38.8553 26.5005 39.66 26.688V12.394H34.7814V26.6798C35.5761 26.4982 36.3888 26.4057 37.2036 26.4077ZM41.2754 27.2024L41.2734 11.5875C41.2734 11.3738 41.1887 11.168 41.0375 11.0167C40.8862 10.8655 40.6805 10.7808 40.4667 10.7808H33.9748C33.5291 10.7808 33.1681 11.1418 33.1681 11.5875V27.1863C32.0952 27.62 31.0989 28.223 30.2176 28.9713V19.5545C30.2176 19.3407 30.1329 19.135 29.9816 18.9837C29.8304 18.8324 29.6246 18.7477 29.4108 18.7477H22.919C22.4732 18.7477 22.1122 19.1087 22.1122 19.5545V40.4658C22.1122 40.6816 22.1969 40.8853 22.3482 41.0366C22.4995 41.1878 22.7052 41.2725 22.919 41.2725H27.2026C28.5659 44.6247 31.5165 47.0694 35.0642 47.785C38.6097 48.503 42.2784 47.3957 44.8377 44.8363C47.395 42.2789 48.5022 38.6099 47.7862 35.0622C47.0703 31.5165 44.6239 28.5637 41.2742 27.2001L41.2754 27.2024ZM26.688 39.6588H23.7234L23.7254 20.361H28.604V30.6757C26.6638 33.2371 25.96 36.5288 26.688 39.6588ZM37.2034 28.0213C34.7692 28.0213 32.4317 28.9874 30.7115 30.7098C28.9892 32.4322 28.0212 34.7678 28.0212 37.2042C28.0212 39.6385 28.9892 41.9742 30.7115 43.6965C32.4318 45.4189 34.7673 46.387 37.2034 46.387C39.6396 46.387 41.9751 45.4189 43.6953 43.6965C45.4176 41.974 46.3857 39.6384 46.3857 37.2042C46.3857 34.7677 45.4176 32.4321 43.6973 30.7098C41.975 28.9874 39.6396 28.0192 37.2034 28.0213ZM0.806711 26.5791H7.2986C7.51238 26.5791 7.71809 26.6639 7.86936 26.8151C8.02062 26.9664 8.10533 27.1721 8.10533 27.3859V40.4656C8.10533 40.6814 8.02062 40.8851 7.86936 41.0364C7.7181 41.1876 7.51239 41.2723 7.2986 41.2723H0.806711C0.361004 41.2723 0 40.9113 0 40.4656V27.3859C0 26.9402 0.361004 26.5791 0.806711 26.5791ZM6.49215 28.1927H1.61358V39.6588H6.49215V28.1927ZM4.48547 14.8389L15.2187 8.00371L25.9158 11.4789C26.1941 11.5696 26.5007 11.501 26.7145 11.3014L36.8044 2.99777L36.512 4.74239C36.4394 5.18208 36.7359 5.59552 37.1735 5.67019C37.6131 5.74279 38.0265 5.44631 38.1012 5.0066L38.7486 1.14219V1.14421C38.8212 0.704522 38.5247 0.289064 38.0871 0.216417L34.0798 0.000606674C33.6361 -0.0195622 33.261 0.321293 33.2388 0.763017C33.2166 1.20472 33.5554 1.58186 33.9971 1.60809L35.8445 1.7049L25.9967 9.81075L15.3584 6.35377V6.35579C15.1305 6.28116 14.8804 6.31343 14.6788 6.44252L3.62283 13.4837C3.24772 13.7217 3.13679 14.2179 3.37679 14.593C3.61477 14.9661 4.11091 15.077 4.486 14.839L4.48547 14.8389ZM17.5503 16.4604H12.6697V39.6591H17.5483L17.5503 16.4604Z'
                  fill='#F39B38'
                />
              </svg>
            </span>
            <span className='descriptionBlockPointTitle'>Revenue Cycle Assessment</span>
            <span className='descriptionBlockPointText'>
              Comprehensive end-to-end analysis that identifies improvement opportunities, defines benchmarks, and creates your
              optimization roadmap.
            </span>
            <div className='descriptionBlockPointItems'>
              <ul className='descriptionBlockPointList'>
                <li>Front-End Process Analysis</li>
                <li>Mid-Cycle Operations Review</li>
                <li>Back-End Collections Assessment</li>
              </ul>
              <ul className='descriptionBlockPointList'>
                <li>Data Analysis & Benchmarking</li>
                <li>KPI Definition & Tracking</li>
                <li>Implementation Roadmap</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className='solutionsSteps'>
        <div className='solutionsStepsContent'>
          <span className='blockTitle'>Our Proven Approach</span>
          <span className='blockText'>Closing the gap between people, processes, and technology</span>
          <div className='solutionsStepsContainer'>
            <div className='solutionsStep'>
              <span className='solutionsStepTitle'>Assessment</span>
              <span className='solutionsStepIcon'>1</span>
              <span className='solutionsStepText'>Thorough analysis of current people, processes, and technology.</span>
            </div>

            <div className='solutionsStep'>
              <span className='solutionsStepTitle'>Customization</span>
              <span className='solutionsStepIcon'>2</span>
              <span className='solutionsStepText'>Tailored solutions designed to meet your specific needs.</span>
            </div>

            <div className='solutionsStep'>
              <span className='solutionsStepTitle'>Implementation</span>
              <span className='solutionsStepIcon'>3</span>
              <span className='solutionsStepText'>Expert guidance and support throughout the transformation.</span>
            </div>

            <div className='solutionsStep'>
              <span className='solutionsStepTitle'>Optimization</span>
              <span className='solutionsStepIcon'>4</span>
              <span className='solutionsStepText'>Continuous improvement and bottom-line impact measurement.</span>
            </div>
          </div>
        </div>
      </div>

      <div className='solutionsStats'>
        <div className='solutionsStat'>
          <span className='solutionsStatCount'>30+</span>
          <span className='solutionsStatTitle'>
            Years in <br />
            Business
          </span>
        </div>

        <div className='solutionsStat'>
          <span className='solutionsStatCount'>1000+</span>
          <span className='solutionsStatTitle'>
            Successful <br />
            Placements
          </span>
        </div>

        <div className='solutionsStat'>
          <span className='solutionsStatCount'>50+</span>
          <span className='solutionsStatTitle'>
            States <br />
            Served
          </span>
        </div>

        <div className='solutionsStat'>
          <span className='solutionsStatCount'>24/7</span>
          <span className='solutionsStatTitle'>
            Client <br />
            Support
          </span>
        </div>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <PreFooter
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
        title='Ready to Transform Your Revenue Cycle?'
        text='Schedule a consultation to discuss your revenue cycle optimization needs and discover how we can drive your bottom-line results.'
      />
      <Footer />
    </div>
  );
};

export default MainPage;
